module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/season/2008_sunflower-32133a532455057dbd817e049b02804a.jpg";